export const CROP_TYPES = {
  RICE: "Rice",
};
